import { useEffect } from 'react';
import { usePlatformConfig } from '@/hooks/usePlatformConfig';
import { getSiteSocialLinks } from '@/lib/siteSocialLinks';

/** Keeps static #site-social-crawl anchors in sync with admin-configured social URLs. */
export function SiteSocialCrawlSync() {
  const { ready } = usePlatformConfig();
  const links = getSiteSocialLinks();
  const key = `${ready}:${links.map((l) => `${l.platform}:${l.href}`).join('|')}`;

  useEffect(() => {
    const nav = document.getElementById('site-social-crawl');
    if (!nav || links.length === 0) return;

    nav.replaceChildren();
    links.forEach((link, index) => {
      if (index > 0) {
        nav.appendChild(document.createTextNode(' · '));
      }
      const anchor = document.createElement('a');
      anchor.href = link.href;
      anchor.textContent = link.label;
      anchor.style.color = '#b45309';
      anchor.style.fontWeight = '600';
      anchor.rel = link.platform === 'instagram' ? 'me noopener noreferrer' : 'noopener noreferrer';
      nav.appendChild(anchor);
    });
  }, [key, links]);

  return null;
}
